import client from './client';

export default {
  all(page = 1) {
    return client.get('/doctors')
      .query({
        page: page
      })
      .end();
  },

  allForOffice(params) {
    return client.get(`/offices/${params.officeId}/doctors`)
      .end();
  },

  availabilitiesCreate(params) {
    return client.post(`/doctors/${params.doctorId}/doctor_availabilities`)
      .send(params)
      .end();
  },

  availabilitiesDelete(params) {
    return client.delete(`/doctor_availabilities/${params.id}`)
      .end();
  },

  availabilitiesFetch(params) {
    return client.get('/doctor_availabilities')
      .query(params)
      .end();
  },

  availabilitiesFetchForOffice(params) {
    return client.get(`/offices/${params.officeId}/doctor_availabilities`)
      .query(params)
      .end();
  },

  create(params) {
    return client.post('/doctors')
      .send(params)
      .end();
  },

  delete(params) {
    return client.delete(`/doctors/${params.id}`)
      .end();
  },

  edit(params) {
    return client.patch(`/doctors/${params.id}`)
      .send(params)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/doctorAPI.js